import ApiService, { HttpMethod } from "../../commons/api/api_service";
import BaseResponse from "../../commons/api/base_response";
import { Endpoints } from "../../commons/api/endpoints";
import ViewModelV2 from "../../commons/base/v2/view_model";
import { GeneralDOIResponse } from "../models/doi_dashboard_models";
import { Item, ResponseModel } from "../models/stock_dashboard_models";

// const PAGE_ROWS = 20;

export default class StockDashboardVM extends ViewModelV2 {

    isLoading = true;
    data: Item[] = [];
    pagedData = new Map<number, Item[]>();
    currentPage: number = 1;
    outlet: string = "";

    constructor(outlet: string) {
        super();
        this.loadData({outlet: outlet});
    }

    loadData(params: {outlet: string}) {
        ApiService.fetchWithQueryParams<typeof params, BaseResponse<ResponseModel>, {outlet: string}>(
            Endpoints.getOutletStock,
            {
                httpMethod: HttpMethod.get,
                queryParameters: params,
                onSuccess: (response) =>  {
                    this.emit(() => {
                        this.isLoading = false;
                        this.data = response.data ?? [];
                        this.data = this.data.filter((data) => data.qty >= 0.01);

                        // parse DOI data from LocalStorage, then add DOI values to items object
                        const storage = window.localStorage;
                        let doiData = JSON.parse(storage.getItem(Endpoints.getGeneralDOI) ?? "[]") as typeof GeneralDOIResponse;

                        if (doiData.length > 0) {
                            const myDoiData = doiData.filter((d) => d.location.label === this.outlet)[0];

                            const myDoiMap = new Map<number, number>();
                            myDoiData.itemsLowDOI.forEach((item) => {
                                myDoiMap.set(item.itemId, item.doi);
                            });

                            this.data.forEach((data) => {
                                data.doi = myDoiMap.get(data.id);
                            });

                            this.data = this.data.sort((A, B) => (A.doi ?? 0) - (B.doi ?? 0));
                        }
                        // this.sliceAsPages();
                        // this.data = this.pagedData.get(1) ?? [];
                    });
                },
                onFailure: (error) => {
                    this.emit(() => {
                        this.isLoading = false;
                    });
                }
            }
        )
    }

    // sliceAsPages() {
    //     const maxPage = this.data.length / PAGE_ROWS;
    //     let curr = 0;
    //     for (let i = 0; i < maxPage; i++) {
    //         const part = this.data.slice(curr, PAGE_ROWS*i)
    //         if (part.length > 0) {
    //             this.pagedData.set(i, part);
    //             curr = PAGE_ROWS*i;
    //         }
    //     }
    // }
}